import React from 'react';
import { TFunction } from 'i18next';
import { WidgetsKindEnum } from 'graphql-common';
import { FieldItem, Values } from '@lib/interfaces/form';
import SupportiveMessage, {
  SupportiveMessageColor,
  SupportiveMessageIconColor,
  SupportiveMessageType,
} from '@lib/components/SupportiveMessage/SupportiveMessage';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import LocationSelect from '@lib/components/LocationSelect/LocationSelect';
import {
  isWidgetSelected,
  getConditionalLocationValidation,
} from './validationHelpers';

/**
 * Returns fields for Weather Week widget
 */
export default function getWeatherWeekFields(t: TFunction): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.WeatherWeekInfo,
      customRender: () => (
        <SupportiveMessage
          text={t('home.widget-weather-weak-info')}
          leftIcon="info"
          color={SupportiveMessageColor.Gray}
          iconColor={SupportiveMessageIconColor.Inner}
          type={SupportiveMessageType.Transparent}
          hasBottomSpace={false}
        />
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.WeatherWeek),
    },
    {
      name: WidgetFieldNames.WeatherWeekLocation,
      label: t('location'),
      element: LocationSelect,
      validation: getConditionalLocationValidation(
        t,
        WidgetsKindEnum.WeatherWeek,
      ),
      isVisibleFn: (values: Values) =>
        isWidgetSelected(values, WidgetsKindEnum.WeatherWeek),
    },
  ];
}
